import createIcon from '../../createIcon';

/**
 * @component @name FolderCopy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA2LjVIMVYxOS41QzEgMjAuNiAxLjkgMjEuNSAzIDIxLjVIMjBWMTkuNUgzVjYuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSA0LjVIMTRMMTIgMi41SDdDNS45IDIuNSA1LjAxIDMuNCA1LjAxIDQuNUw1IDE1LjVDNSAxNi42IDUuOSAxNy41IDcgMTcuNUgyMUMyMi4xIDE3LjUgMjMgMTYuNiAyMyAxNS41VjYuNUMyMyA1LjQgMjIuMSA0LjUgMjEgNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FolderCopy = createIcon('FolderCopy', [
  ['path', { d: 'M3 6.5H1V19.5C1 20.6 1.9 21.5 3 21.5H20V19.5H3V6.5Z', key: 'wwtqub' }],
  [
    'path',
    {
      d: 'M21 4.5H14L12 2.5H7C5.9 2.5 5.01 3.4 5.01 4.5L5 15.5C5 16.6 5.9 17.5 7 17.5H21C22.1 17.5 23 16.6 23 15.5V6.5C23 5.4 22.1 4.5 21 4.5Z',
      key: 'ody5y7',
    },
  ],
]);

export default FolderCopy;
